import React, { useEffect } from "react";

const PRICING_TABLE_ID = "prctbl_1TcrtLCBpoaNcNVrluK6V4dC";
const PUBLISHABLE_KEY =
  "pk_live_51Ta3ZxCBpoaNcNVr6NZUhib7Vgg9lbgnbsIXkimCvng1FUsZ77sawBiSr70yxs7bHUUBueKq0YwAlSezZ5kzmYxQ00BqK6oSMY";
const SCRIPT_SRC = "https://js.stripe.com/v3/pricing-table.js";

/**
 * Embeds the Stripe Pricing Table on the page. Requires the user to be signed
 * in: `customer-email` pre-fills Stripe checkout, and `client-reference-id`
 * carries our Plainly user_id through so the backend can match the resulting
 * Checkout Session back to the user on /payment-success.
 */
export function StripePricingTable({ email, userId }) {
  useEffect(() => {
    if (document.querySelector(`script[src="${SCRIPT_SRC}"]`)) return;
    const script = document.createElement("script");
    script.src = SCRIPT_SRC;
    script.async = true;
    document.head.appendChild(script);
  }, []);

  return (
    <div data-testid="stripe-pricing-table-wrapper">
      <stripe-pricing-table
        pricing-table-id={PRICING_TABLE_ID}
        publishable-key={PUBLISHABLE_KEY}
        customer-email={email || undefined}
        client-reference-id={userId || undefined}
      />
    </div>
  );
}
